export default __webpack_public_path__ + "static/media/al.1eab2e43.png";